"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAValidator = exports.IAValidatorKeys = void 0;
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const RolEchainCalculatorFactory_1 = require("../rolEchain/RolEchainCalculatorFactory");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
// prettier-ignore
class IAValidatorKeys {
}
exports.IAValidatorKeys = IAValidatorKeys;
IAValidatorKeys.KETTE_GLIEDER_COUNT_NOT_DEFINED = 'KETTE_GLIEDER_COUNT_NOT_DEFINED';
IAValidatorKeys.KETTE_GLIEDER_COUNT_LESS_THEN_0 = 'KETTE_GLIEDER_COUNT_LESS_THEN_0';
IAValidatorKeys.IA_OFFSET_GLIEDER_NOT_DEFINED = 'IA_OFFSET_GLIEDER_NOT_DEFINED';
IAValidatorKeys.IA_OFFSET_GLIEDER_LESS_THEN_1 = 'IA_OFFSET_GLIEDER_LESS_THEN_1';
IAValidatorKeys.IA_INTERVAL_GLIEDER_NOT_DEFINED = 'IA_INTERVAL_GLIEDER_NOT_DEFINED';
IAValidatorKeys.IA_INTERVAL_GLIEDER_LESS_THEN_1 = 'IA_INTERVAL_GLIEDER_LESS_THEN_1';
IAValidatorKeys.IA_OFFSET_GREATER_THEN_GLIEDER_COUNT = 'IA_OFFSET_GREATER_THEN_GLIEDER_COUNT';
IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE = 'IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE';
IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE = 'IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE';
IAValidatorKeys.IA_OFFSET_GLIEDER_INVALID_FOR_ESKIN = 'IA_OFFSET_GLIEDER_INVALID_FOR_ESKIN';
IAValidatorKeys.IA_INTERVAL_GLIEDER_INVALID_FOR_ESKIN = 'IA_INTERVAL_GLIEDER_INVALID_FOR_ESKIN';
IAValidatorKeys.IA_OFFSET_GLIEDER_INVALID_FOR_SMART_PLASTICS = 'IA_OFFSET_GLIEDER_INVALID_FOR_SMART_PLASTICS';
IAValidatorKeys.IA_UNKNOWN_KETTEN_SERIE_FOR_HALBSTEGIGE_KETTE = 'IA_UNKNOWN_KETTEN_SERIE_FOR_HALBSTEGIGE_KETTE';
IAValidatorKeys.IA_OFFSET_GLIEDER_INVALID_FOR_ROL_ECHAIN = 'IA_OFFSET_GLIEDER_INVALID_FOR_ROL_ECHAIN';
/**
 * The `IAValidator` performs validations on an `IA`.
 */
class IAValidator {
    static validateCountForRolEchain(ia, rolEchain, keyPrefix = '') {
        const validation = IAValidator.validateStandardIaAspects({
            numGlieder: RolEchainCalculatorFactory_1.RolEchainCalculatorFactory.getCalculator(rolEchain).calcTotalNumLinks(rolEchain),
            ia,
            validation: echain_shared_validation_1.Validation.empty(),
            keyPrefix,
        });
        return validation;
    }
    static validateCountForKette(ia, kette, keyPrefix = '', options = {}) {
        return this.validCountForKette(ia, kette, undefined, keyPrefix, options);
    }
    /** @deprecated use validateCountForKette instead */
    static validCountForKette(ia, kette, logger, keyPrefix = '', options = {}) {
        const validation = IAValidator.validateStandardIaAspects({
            numGlieder: kette.numGlieder,
            ia,
            validation: echain_shared_validation_1.Validation.empty(),
            keyPrefix,
        });
        validation.add(this.validateSmartPlastics(ia, kette, keyPrefix, options));
        // TODO: EKE-12701 make use of switch case !!
        if (kette.isSerieESkin()) {
            if (ia.startingAtNthKettenglied !== 2) {
                validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_GLIEDER_INVALID_FOR_ESKIN);
            }
            if (ia.perNthKettenglied !== 1) {
                validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_GLIEDER_INVALID_FOR_ESKIN);
            }
        }
        if (!validation.hasIssues() && kette.halbstegig) {
            const halbstegigValidation = IAValidator.validateCountForHalbstegigeKette(ia, kette, keyPrefix);
            validation.add(halbstegigValidation);
        }
        return validation;
    }
    static validateStandardIaAspects({ numGlieder, ia, validation, keyPrefix, }) {
        if (ia.manualCount)
            return validation;
        if (!(numGlieder || numGlieder === 0)) {
            validation.add(keyPrefix + IAValidatorKeys.KETTE_GLIEDER_COUNT_NOT_DEFINED);
        }
        else if (numGlieder < 0) {
            validation.add(keyPrefix + IAValidatorKeys.KETTE_GLIEDER_COUNT_LESS_THEN_0);
        }
        if (!(ia.startingAtNthKettenglied || ia.startingAtNthKettenglied === 0)) {
            validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_GLIEDER_NOT_DEFINED);
        }
        else if (ia.startingAtNthKettenglied < 1) {
            validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_GLIEDER_LESS_THEN_1);
        }
        if (!(ia.perNthKettenglied || ia.perNthKettenglied === 0)) {
            validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_GLIEDER_NOT_DEFINED);
        }
        if (!validation.hasIssues() && ia.startingAtNthKettenglied != null && numGlieder != null) {
            const offsetKettenglieder = ia.startingAtNthKettenglied - 1;
            const kettengliederRest = numGlieder - offsetKettenglieder;
            if (kettengliederRest <= 0) {
                validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_GREATER_THEN_GLIEDER_COUNT);
            }
        }
        return validation;
    }
    static validateSmartPlastics(ia, _kette, keyPrefix = '', options = {}) {
        const validation = echain_shared_validation_1.Validation.empty();
        if (options.isSmartPlastics && !ia.isSmartPlasticsSeparator() && ia.startingAtNthKettenglied === 1) {
            validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_GLIEDER_INVALID_FOR_SMART_PLASTICS);
        }
        return validation;
    }
    static validateCountForHalbstegigeKette(ia, kette, keyPrefix = '') {
        const validation = echain_shared_validation_1.Validation.empty();
        if (ia.manualCount)
            return validation;
        if (!ia.startingAtNthKettenglied || !ia.perNthKettenglied) {
            return validation;
        }
        const numKettenglieder = kette.numGlieder;
        let firstEvenGliedFilled = -1;
        let firstOddGliedFilled = -1;
        const isCountEven = (numKettenglieder & 1) === 0;
        const isOffsetEven = (ia.startingAtNthKettenglied & 1) === 0;
        const isIntervalEven = (ia.perNthKettenglied & 1) === 0;
        if (isOffsetEven && isIntervalEven) {
            firstEvenGliedFilled = ia.startingAtNthKettenglied;
        }
        else if (!isOffsetEven && isIntervalEven) {
            firstOddGliedFilled = ia.startingAtNthKettenglied;
        }
        else if (isOffsetEven && !isIntervalEven) {
            firstEvenGliedFilled = ia.startingAtNthKettenglied;
            firstOddGliedFilled = ia.startingAtNthKettenglied + ia.perNthKettenglied;
        }
        else {
            // (!isOffsetEven && !isIntervalEven)
            firstOddGliedFilled = ia.startingAtNthKettenglied;
            firstEvenGliedFilled = ia.startingAtNthKettenglied + ia.perNthKettenglied;
        }
        const kettenSystem = (0, echain_shared_articles_1.findKettenSystemGroup)(kette.toModel());
        if (kettenSystem === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00) {
            if (isCountEven) {
                if (kette.isMontageMitnehmer) {
                    if (isOffsetEven) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                    if (!isIntervalEven && firstEvenGliedFilled <= numKettenglieder) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                }
                else {
                    if (!isOffsetEven) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                    if (!isIntervalEven && firstOddGliedFilled <= numKettenglieder) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                }
            }
            else {
                if (isOffsetEven) {
                    validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                }
                if (!isIntervalEven && firstEvenGliedFilled <= numKettenglieder) {
                    validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                }
            }
        }
        else if (kettenSystem === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E61_OR_E6) {
            if (isCountEven) {
                if (kette.isMontageMitnehmer) {
                    if (!isOffsetEven) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                    if (!isIntervalEven && firstOddGliedFilled <= numKettenglieder) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                }
                else {
                    if (isOffsetEven) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                    if (!isIntervalEven && firstEvenGliedFilled <= numKettenglieder) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                }
            }
            else {
                if (!isOffsetEven) {
                    validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                }
                if (!isIntervalEven && firstOddGliedFilled <= numKettenglieder) {
                    validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                }
            }
        }
        else if (kettenSystem === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light) {
            if (isCountEven) {
                if (kette.isMontageMitnehmer) {
                    if (isOffsetEven) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                    if (!isIntervalEven && firstEvenGliedFilled <= numKettenglieder) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                }
                else {
                    if (!isOffsetEven) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                    if (!isIntervalEven && firstOddGliedFilled <= numKettenglieder) {
                        validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                    }
                }
            }
            else {
                if (!isOffsetEven) {
                    validation.add(keyPrefix + IAValidatorKeys.IA_OFFSET_INVALID_FOR_HALBSTEGIGE_KETTE);
                }
                if (!isIntervalEven && firstOddGliedFilled <= numKettenglieder) {
                    validation.add(keyPrefix + IAValidatorKeys.IA_INTERVAL_INVALID_FOR_HALBSTEGIGE_KETTE);
                }
            }
        }
        else {
            validation.add(keyPrefix + IAValidatorKeys.IA_UNKNOWN_KETTEN_SERIE_FOR_HALBSTEGIGE_KETTE);
        }
        return validation;
    }
}
exports.IAValidator = IAValidator;
//# sourceMappingURL=IAValidator.js.map